import { render } from "./Launchpad.vue?vue&type=template&id=0b980fa9&scoped=true&ts=true"
import script from "./Launchpad.vue?vue&type=script&lang=ts"
export * from "./Launchpad.vue?vue&type=script&lang=ts"

import "./Launchpad.vue?vue&type=style&index=0&id=0b980fa9&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b980fa9"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QPageScroller from 'quasar/src/components/page-scroller/QPageScroller.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QLayout,QTooltip,QBtn,QSkeleton,QPageScroller,QIcon,QScrollArea});
